/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
/**
 * 
 * @export
 * @interface V1SearchResultLocalProfilePoiCategory
 */
export interface V1SearchResultLocalProfilePoiCategory {
    /**
     * 
     * @type {Array<string>}
     * @memberof V1SearchResultLocalProfilePoiCategory
     */
    themeIds: Array<string>;
}

/**
 * Check if a given object implements the V1SearchResultLocalProfilePoiCategory interface.
 */
export function instanceOfV1SearchResultLocalProfilePoiCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "themeIds" in value;

    return isInstance;
}

export function V1SearchResultLocalProfilePoiCategoryFromJSON(json: any): V1SearchResultLocalProfilePoiCategory {
    return V1SearchResultLocalProfilePoiCategoryFromJSONTyped(json, false);
}

export function V1SearchResultLocalProfilePoiCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1SearchResultLocalProfilePoiCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'themeIds': json['theme_ids'],
    };
}

export function V1SearchResultLocalProfilePoiCategoryToJSON(value?: V1SearchResultLocalProfilePoiCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'theme_ids': value.themeIds,
    };
}

